export default "__VITE_ASSET__Cu8$Aoug__"